import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Container from 'components/Container';
import EmailInput from 'components/form-inputs/EmailInput';
import TitanLogoImage from 'assets/images/authentication/titan-logo.png';
import AuthHeaderImage from 'assets/images/authentication/auth-image.png';
import { Message } from 'components/shared';
import { useForm } from 'react-hook-form';
import useForgottenPasswordUtility from './utilityForgottenPassword/useForgottenPasswordUtility';

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: 0,
    marginTop: '14px'
  },
  displayFlex: {
    display: 'flex'
  },
  loginButton: {
    textTransform: 'none',
    padding: '10px 13px',
    fontSize: '14px',
    marginTop: '26px'
  },
  messageBox: {
    marginTop: '10px'
  }
}));

const ForgottenPassword = () => {
  const [sendResetPasswordRequest] = useForgottenPasswordUtility();

  const { register, handleSubmit } = useForm();
  const [emailAddress, setEmailAddress] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleEmailChange = event => {
    setEmailAddress(event.target.value);
  };
  const handleForgottenPasswordClick = () => {
    setIsSubmitted(true);
    sendResetPasswordRequest(emailAddress, window.location.origin.toString());
  };
  const classes = useStyles();
  return (
    <Container size={100} center background="#346C9F">
      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src={TitanLogoImage}
            alt="alt"
            display="flex"
            maxWidth="100%"
            pb={2}
            px={3}
          />
          <Box width="100%" bgcolor="#fff" borderRadius="4px">
            <Box component="img" src={AuthHeaderImage} alt="alt" display="flex" maxWidth="100%" />
            <Box p={3}>
              <form onSubmit={handleSubmit(handleForgottenPasswordClick)}>
                <Typography variant="subtitle2">
                  Type the e-mail that your account is associated with.
                </Typography>
                <Typography variant="subtitle2" className={classes.heading}>
                  Your E-mail
                </Typography>
                <EmailInput
                  label="Email"
                  type="email"
                  fullWidth
                  defaultValue={emailAddress}
                  required
                  ref={register({
                    required: 'Enter your e-mail',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: 'Enter a valid e-mail address'
                    }
                  })}
                  onChange={handleEmailChange}
                  margin="dense"
                />

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.loginButton}
                  type="submit"
                >
                  Reset Password
                </Button>
              </form>
              <Box className={classes.messageBox}>
                {isSubmitted && (
                  <Message
                    type="success"
                    text="Check your email for link to set up a new password"
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ForgottenPassword;
